import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  startCta: {
    id: 'homeScreen_miniPlayer_start_CTA',
  },
  backToHomeCta: {
    id: 'web_ea_eos_words_back_to_home',
  },

  learnTitle: {
    id: 'homeScreen_learnWords',
  },
  notStartedScenarioDescription: {
    id: 'homeScreen_miniPlayer_unstartedScenario_prefix_web',
  },
  startedScenarioDescription: {
    id: 'homeScreen_miniPlayer_scenarioInProgress_prefix_web',
  },
  disabledLearnDescription: {
    id: 'homeScreen_miniPlayer_unavailableScenarioRecommendations',
  },

  immerseTitle: {
    id: 'homeScreen_hearMyWords',
  },
  immerseDescription: {
    id: 'homeScreen_miniPlayer_hearMyWords_description',
  },
  immerseCustomRecommendation: {
    id: 'eos_recommendationCard_immerseVideoFromScenario',
  },
  disabledImmerseDescription: {
    id: 'homeScreen_miniPlayer_videosOrCommunicateUnavailable_description',
  },

  communicateTitle: {
    id: 'homeScreen_useMyWords',
  },
  communicateDescription: {
    id: 'homeScreen_miniPlayer_useMyWords_description',
  },
  disabledCommunicateDescription: {
    id: 'homeScreen_miniPlayer_videosOrCommunicateUnavailable_description',
  },
});
